import type { NavSectionProps } from '@classroom-ai/ui/components/nav-section';

import { uiConfig } from '@classroom-ai/ui';
import { SvgColor } from '@classroom-ai/ui/components/svg-color';

import { paths } from 'src/routes/paths';

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor src={`${uiConfig.assetsDir}/assets/icons/navbar/${name}.svg`} />
);

const ICONS = {
  classes:  icon('ic-course'),
  overview: icon('ic-dashboard'),
  history:  icon('ic-analytics'),
};

// ----------------------------------------------------------------------

export const navData: NavSectionProps['data'] = [
  {
    subheader: 'Learning',
    items: [
      {
        title: 'My Classes',
        path: paths.dashboard.classes,
        icon: ICONS.classes,
      },
      {
        title: 'Class Overview',
        path: paths.dashboard.overview,
        icon: ICONS.overview,
      },
      {
        title: 'Past Sessions',
        path: paths.dashboard.pastSessions,
        icon: ICONS.history,
        // Stays active on a session's recap (/past-sessions/:sessionId, epic #463).
        deepMatch: true,
      },
    ],
  },
];
